module.exports = __webpack_public_path__ + "static/media/mayank-sagar.1b0baae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mayank-sagar.jpg
// module id = 291
// module chunks = 0